/**
 * Donation-related enums and constants
 */

// Donation Type
export const DONATION_TYPES = [
  'personal',
  'participant',
  'team',
  'event',
  'registration',
  'general',
  'items',
  'random',
] as const;
export type DonationType = (typeof DONATION_TYPES)[number];

// Donation Status
export const DONATION_STATUSES = [
  'pending',
  'processing',
  'paid',
  'failed',
  'refunded',
  'partially_refunded',
  'cancelled',
] as const;
export type DonationStatus = (typeof DONATION_STATUSES)[number];

// Payment Gateway
export const PAYMENT_GATEWAYS = ['stripe', 'adyen', 'paypal', 'manual'] as const;
export type PaymentGateway = (typeof PAYMENT_GATEWAYS)[number];

// Payment Method
export const PAYMENT_METHODS = [
  'card',
  'visa',
  'mastercard',
  'amex',
  'discover',
  'diners',
  'jcb',
  'unionpay',
  'carte_bancaire',
  'maestro',
  'apple_pay',
  'google_pay',
  'ideal',
  'sepa_direct_debit',
  'bancontact',
  'twint',
  'eps',
  'multibanco',
  'paypal',
  'paypal_wallet',
  'paypal_bank',
  'cash',
  'bank_transfer',
  'cheque',
  'pos',
  'invoice',
  'gift_match',
] as const;
export type KnownPaymentMethod = (typeof PAYMENT_METHODS)[number];
export type PaymentMethod = KnownPaymentMethod | (string & {});

// Settled Donation Statuses — webhook has resolved the donation, no SDK finalization needed
export const SETTLED_DONATION_STATUSES = [
  'paid',
  'failed',
  'refunded',
  'partially_refunded',
  'cancelled',
] as const;
export type SettledDonationStatus = (typeof SETTLED_DONATION_STATUSES)[number];

// Allowed Status Transitions
export const ALLOWED_STATUS_TRANSITIONS: Record<DonationStatus, readonly DonationStatus[]> = {
  pending: ['processing', 'paid', 'failed', 'cancelled'],
  processing: ['paid', 'failed', 'cancelled'],
  paid: ['partially_refunded', 'refunded', 'cancelled'],
  failed: [],
  refunded: [],
  partially_refunded: ['partially_refunded', 'refunded'],
  cancelled: [],
};

export function isAllowedStatusTransition(
  currentStatus: DonationStatus,
  nextStatus: DonationStatus,
): boolean {
  return ALLOWED_STATUS_TRANSITIONS[currentStatus].includes(nextStatus);
}

// FX Reconciliation Status
export const FX_RECONCILIATION_STATUSES = ['not_started', 'pending', 'resolved'] as const;
export type FxReconciliationStatus = (typeof FX_RECONCILIATION_STATUSES)[number];
